import React, { Component, createRef } from 'react';
import IconNotFound from '../../assets/icons/IconNotFound';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faSearch, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

class DropdownFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: '',
            keyword: '',
            isOpened: false
        }
    }

    handleSelect = async data => {
        await this.setState({
            selected: data,
            isOpened: false,
            keyword: ''
        })
        await this.props.handleChange(data);
        if (this.props.handleReset !== undefined) {
            this.props.handleReset();
        }
    }

    handleSearch = async e => {
        await this.setState({ keyword: e.target.value })
        this.props.getSearchData(this.state.keyword);
    }

    handleOpen = () => {
        this.setState({
            isOpened: !this.state.isOpened
        })
    }

    handleClear = async () => {
        this.setState({
            keyword: ''
        })
        this.props.getListData();
    }

    handleClearSelect = () => {
        this.setState({
            isOpened: false,
            selected: ''
        })
        this.props.handleChange('')
    }

    handleDropdown = e => {
        if (this.dropdownRef && this.inputRef && !this.dropdownRef.current.contains(e.target) && !this.inputRef.current.contains(e.target)) {
            this.setState({
                isOpened: false
            })
        }
    }

    selectedValue = () => {
        if (this.props.reset) {
            return this.props.placeholder
        }
        return this.state.selected !== '' ? this.state.selected.label : this.props.placeholder
    }

    componentDidMount() {
        this.dropdownRef = createRef()
        this.inputRef = createRef()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpened !== this.state.isOpened) {
            if (this.state.isOpened) {
                document.addEventListener('click', this.handleDropdown)
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDropdown)
    }

    render() {
        return (
            <div id={this.props.id} className={this.state.isOpened ? "dropdown opened" : "dropdown"} tabIndex="-1">
                <div className="dropdown-select" id="btndropdown" onClick={() => this.handleOpen()} ref={this.dropdownRef}>
                    <span className={this.state.selected !== '' && !this.props.reset ? "select truncate" : "select text-gray-500"}>
                        {this.selectedValue()}
                    </span>
                    <span>
                        {this.state.selected !== '' && this.props.clearButton && <FontAwesomeIcon icon={faTimes} className="fa-lg text-gray-300 border-r border-gray-300 hover:text-gray-400 pr-3 mr-3" id="btndropdownclearselect" onClick={this.handleClearSelect} />}
                        <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                    </span>
                </div>
                <div className={this.state.isOpened ? "absolute top-full w-full z-50" : "hidden"} >
                    <div className="bg-darkblue w-full h-12 rounded-t-md p-3 mt-1" ref={this.inputRef}>
                        <div className="flex rounded-full bg-white px-2">
                            <div className="mr-2">
                                <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                            </div>
                            <input type="text" id="tslkeyword" placeholder={this.props.searchPlaceholder} className="outline-none w-full" value={this.state.keyword} onChange={this.handleSearch} />
                            <div className="ml-1">
                                <FontAwesomeIcon icon={faTimesCircle} className="text-gray-400 cursor-pointer" id="btndropdownclear" onClick={this.handleClear} />
                            </div>
                        </div>
                    </div>
                    <div className={this.state.isOpened ? "search-dropdown-list" : "hidden"} style={{ maxHeight: "250px", overflowY: "auto" }}>
                        {
                            this.props.data !== undefined && this.props.data.length > 0 ?
                                this.props.data.map((data, idx) =>
                                    <div className="dropdown-list__item" key={idx} id="btndropdownselect" onClick={() => this.handleSelect(data)}>
                                        {
                                            this.state.selected.value === data.value && !this.props.reset ?
                                                <div className="pt-3 pl-3 pr-3 bg-blue-200" title={data.label}>
                                                    <div className={this.props.data.length === idx + 1 ? "pb-3 flex justify-between items-center" : "pb-3 flex justify-between items-center border-b-2 border-gray"}>
                                                        <div className="truncate">{data.label}</div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="pt-3 pl-3 pr-3 hover:bg-blue-100" title={data.label}>
                                                    <div className={this.props.data.length === idx + 1 ? "pb-3 flex justify-between items-center" : "pb-3 flex justify-between items-center border-b-2 border-gray"}>
                                                        <div className="truncate">{data.label}</div>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                )
                                :
                                <div className="px-3 py-5 text-center flex flex-col items-center">
                                    <IconNotFound />
                                    <p className="text-sm text-darkblue opacity-30 mt-5">Data tidak ditemukan</p>
                                </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default DropdownFilter;